import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RadioGroup, SlideFade, VStack } from '@chakra-ui/react';
import config from 'config/config';
import {
  AnswersSelector,
  RoofAngleSelector,
  RoofTypeSelector,
} from 'store/selectors';
import { updateRoofType } from 'store/answers/answersSlice';
import AppRoutes from 'config/AppRoutes';
import PageLayout from 'ui/layout/PageLayout';
import { RadioWithImage } from 'ui/molecules/RadioWithImage';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import { AssetType, getAsset } from 'utils/hooks/useAsset';

const PageRoofType = () => {
  const currentRoute = AppRoutes.ROOF_TYPE;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { navigateToNextStep, navigateToPreviousStep } =
    useStepNavigation(currentRoute);

  const answers = useSelector(AnswersSelector);
  const roofType = useSelector(RoofTypeSelector);

  const roofAngle = useSelector(RoofAngleSelector);
  const angleFilter = roofAngle > 0 ? 'normal' : 'flat';
  const filteredTypes = config.options.roofTypes.filter(
    (x) => x.filter === angleFilter
  );
  const roofTypeValid = filteredTypes.some((x) => x.id === roofType);

  const handleChange = (newValue: string) => {
    dispatch(updateRoofType(newValue));
  };

  const handleContinue = () => {
    navigateToNextStep();
  };

  // --------------------- effects ------------------------

  // --------------------- render ------------------------

  return (
    <PageLayout
      title={t('ROOF_TYPE_title')}
      buttonLabel={t('common.continue')}
      buttonCallback={handleContinue}
      buttonDisabled={!roofTypeValid}
      backButton
      backCallback={navigateToPreviousStep}
    >
      <RadioGroup
        onChange={handleChange}
        as={VStack}
        defaultValue={roofType}
        pt="35px"
        pb="20px"
        w="full"
        maxWidth="500px"
        spacing="13px"
      >
        {filteredTypes.map((item, i) => {
          const subtitleKey = `ROOF_TYPE.${item.id}.subtitle`;
          const hasSubtitle = t(subtitleKey) !== subtitleKey;
          return (
            <SlideFade
              key={item.id}
              in
              offsetX="100px"
              offsetY="0px"
              style={{ width: '100%' }}
              transition={{ enter: { delay: i * 0.05 } }}
            >
              <RadioWithImage
                value={item.id}
                label={t(`ROOF_TYPE.${item.id}`)}
                subtitle={hasSubtitle ? t(subtitleKey) : null}
                image={getAsset(
                  AssetType.IMAGE,
                  `/roofType/${item.id}.png`,
                  answers
                )}
              />
            </SlideFade>
          );
        })}
      </RadioGroup>
    </PageLayout>
  );
};

export default PageRoofType;
